import { Tag } from '@ps/sports-ui-component-library';
import React from 'react';

import { Icon } from '@swf/sports/components';

import styles from './PopularBetBuilderCount.scss';

const PopularBetBuilderCount = ({ count }: { count: number }) => (
  <div className={styles.flameIcon} data-testid="flame-counter">
    <Icon name="flame" size="x3" testId="flame-icon" />
    <Tag className={styles.flameIconBadge}>{count}</Tag>
  </div>
);

export default PopularBetBuilderCount;
